module.exports = __webpack_public_path__ + "assets/flags/be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/be.svg
// module id = 495
// module chunks = 0